export const DefaultFormValue = {
  name: '',
  slugs: '',
  headline: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  short_description: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  website_address: '',
  facebook_link: '',
  instagram_link: '',
  linkedin_link: '',
  youtube_link: '',
  logo: {
    url: '',
    raw: '',
    filename: ''
  },
  image_1: {
    url: '',
    raw: '',
    filename: ''
  },
  image_2: {
    url: '',
    raw: '',
    filename: ''
  },
  is_newcomer: false
}